import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDonations } from '../../../api/donations';
import type { Donation } from '@spi/shared';
import { StatusBadge } from '../shared/StatusBadge';
import { Pagination } from '../shared/Pagination';
import { EmptyState } from '../shared/EmptyState';
import { PageMeta } from '../shared/PageMeta';

export function DonationsPage() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useDonations({ page, limit: 20 });

  return (
    <div className="container mx-auto px-4 py-8">
      <PageMeta title="Donations" description="View your seed donations" path="/marketplace/donations" />
      <h2 className="text-3xl mb-6">Donations</h2>

      {isLoading ? (
        <div className="flex items-center justify-center min-h-[300px]">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
        </div>
      ) : data?.data.length ? (
        <>
          <div className="space-y-3">
            {data.data.map((donation: Donation) => (
              <Link key={donation.id} to={`/marketplace/donations/${donation.id}`} className="card p-5 flex items-center justify-between hover:shadow-lg block">
                <div>
                  <h4 className="font-semibold text-spi-charcoal">{donation.projectTitle}</h4>
                  <p className="text-sm text-spi-slate">
                    {donation.donorOrganization} &rarr; {donation.recipientOrganization} &middot; {donation.askCrop} &middot; {donation.quantityKg > 0 ? `${donation.quantityKg}kg` : ''}{donation.quantityPackets > 0 ? ` ${donation.quantityPackets}pkts` : ''} &middot; ${donation.fairMarketValueUsd.toLocaleString()}
                  </p>
                  <p className="text-xs text-spi-slate mt-1">{new Date(donation.createdAt).toLocaleDateString()}</p>
                </div>
                <StatusBadge status={donation.status} />
              </Link>
            ))}
          </div>
          <Pagination page={data.page} totalPages={data.totalPages} onPageChange={setPage} />
        </>
      ) : (
        <EmptyState title="No donations" description="Donations will appear here when asks are fulfilled." />
      )}
    </div>
  );
}
